import React from 'react'
import SEO from '../../components/SEO'
import Img from 'gatsby-image'
import style from './index.module.css'

function setHtml($html) {
  return { __html: $html }
}

const About = ({ data, transition }) => (
  <div>
    <h2 style={{textAlign: 'center'}}>About</h2>
    <div style={transition && transition.style}>
      <SEO slug={'About'} />
      <div style={{padding: '24px'}}>
        <Img sizes={data.about.childImageSharp.sizes} />
      </div>
      <div
        className={style.inner}
        dangerouslySetInnerHTML={setHtml(data.allMarkdownRemark.edges['0'].node.html)}
      />
    </div>
  </div>
)

export default About

export const query = graphql`
  query about {
    allMarkdownRemark(filter: { frontmatter: { slug: { eq: "about" } } }) {
      edges {
        node {
          html
        }
      }
    }
    about: file(relativePath: { regex: "/about.jpg/" }) {
      childImageSharp {
        sizes(maxWidth: 400, quality: 90) {
          ...GatsbyImageSharpSizes_withWebp_noBase64
        }
      }
    }
  }
  
`



// WEBPACK FOOTER //
// ./src/pages/about/index.js